
import { call, put, takeEvery } from 'redux-saga/effects'

import {
    clearActionType,
    createActionTypes,
    setOperationError,
} from '../common/client/sagas/common';

import { knDataExec } from './serverApi/project';

export const CLOSE_ACTION_TYPE = 'info/CLOSE';
export const SHOW_ACTION_TYPE = 'info/SHOW';
export const SET_OBJECT_INFO = 'info/SET_OBJECT_INFO';

export const GET_OBJECT_INFO_ACTION_TYPE = createActionTypes('info/GET_OBJECT_INFO');
export const GET_OBJECT_OPSUB_ACTION_TYPE = 'info/GET_OBJECT_OPSUB';
export const GET_OBJECT_PARCELA_ACTION_TYPE = 'info/GET_OBJECT_PARCELA';
export const GET_OBJECT_TELESO_ACTION_TYPE = 'info/GET_OBJECT_TELESO';

export default function getActions(dispatch) {
    return {
        close: () => dispatch({
            type: CLOSE_ACTION_TYPE
        }),
        getObjectOpsub: (token, katuzeKod, isknDate, opsubId) => dispatch({
            type: GET_OBJECT_OPSUB_ACTION_TYPE,
            token, katuzeKod, isknDate, opsubId,
            operation: GET_OBJECT_OPSUB_ACTION_TYPE
        }),
        getObjectParcela: (token, katuzeKod, isknDate, parId) => dispatch({
            type: GET_OBJECT_PARCELA_ACTION_TYPE,
            token, katuzeKod, isknDate, parId,
            operation: GET_OBJECT_PARCELA_ACTION_TYPE
        }),
        getObjectTeleso: (token, katuzeKod, isknDate, telId) => dispatch({
            type: GET_OBJECT_TELESO_ACTION_TYPE,
            token, katuzeKod, isknDate, telId,
            operation: GET_OBJECT_TELESO_ACTION_TYPE
        }),
        setObjectInfo: (data) => dispatch({
            type: SET_OBJECT_INFO, data
        }),
        show: () => dispatch({
            type: SHOW_ACTION_TYPE
        }),
    };
}

function* workGetObjectOpsub(options, action) {
    try {
        yield call(clearActionType);
        yield put({type: SHOW_ACTION_TYPE});
        yield put({type: GET_OBJECT_INFO_ACTION_TYPE.DEFAULT});
        yield put({type: GET_OBJECT_INFO_ACTION_TYPE.LOADING});
        const data = yield call(knDataExec, options.serverApi, action);
        yield put({type: GET_OBJECT_INFO_ACTION_TYPE.SUCCESS, data});
    } catch (error) {
        yield call(setOperationError, error, GET_OBJECT_INFO_ACTION_TYPE);
    }
}

export function* watchGetObjectOpsub(options) {
    yield takeEvery(GET_OBJECT_OPSUB_ACTION_TYPE, workGetObjectOpsub, options);
}

function* workGetObjectParcela(options, action) {
    try {
        yield call(clearActionType);
        yield put({type: SHOW_ACTION_TYPE});
        yield put({type: GET_OBJECT_INFO_ACTION_TYPE.DEFAULT});
        yield put({type: GET_OBJECT_INFO_ACTION_TYPE.LOADING});
        const data = yield call(knDataExec, options.serverApi, action);
        yield put({type: GET_OBJECT_INFO_ACTION_TYPE.SUCCESS, data});
    } catch (error) {
        yield call(setOperationError, error, GET_OBJECT_INFO_ACTION_TYPE);
    }
}

export function* watchGetObjectParcela(options) {
    yield takeEvery(GET_OBJECT_PARCELA_ACTION_TYPE, workGetObjectParcela, options);
}

function* workGetObjectTeleso(options, action) {
    try {
        yield call(clearActionType);
        yield put({type: SHOW_ACTION_TYPE});
        yield put({type: GET_OBJECT_INFO_ACTION_TYPE.DEFAULT});
        yield put({type: GET_OBJECT_INFO_ACTION_TYPE.LOADING});
        const data = yield call(knDataExec, options.serverApi, action);
        yield put({type: GET_OBJECT_INFO_ACTION_TYPE.SUCCESS, data});
    } catch (error) {
        yield call(setOperationError, error, GET_OBJECT_INFO_ACTION_TYPE);
    }
}

export function* watchGetObjectTeleso(options) {
    yield takeEvery(GET_OBJECT_TELESO_ACTION_TYPE, workGetObjectTeleso, options);
}
